/** Whether `pathname` is a page of the Notify app: exactly `/notify` or under
 * `/notify/` (so `/notify-xyz` or `/notifications` never match). Used by App.tsx
 * (no web-demo chrome) and PrivateRoute.tsx (reviewers allowed). The same rule
 * is written out in public/notify/sw.js, which can't import this; keep them in
 * step. */
export const isNotifyPath = (pathname: string) =>
  pathname === "/notify" || pathname.startsWith("/notify/");

/** The file extensions served as files, not as a page: the list in the SPA rules
 * of terraform/amplify.tf (amplify.test.ts keeps the two in step). */
const FILE_EXTENSION = /\.(css|gif|ico|jpg|js|png|txt|svg|woff|woff2|ttf|map|json|webp|wasm)$/;

/** Whether a request for `pathname` gets notify/index.html (the HTML with the
 * Notify manifest, UI-04): a Notify page, not one of its files (/notify/sw.js,
 * /notify/manifest.json). Amplify's rewrite in terraform/amplify.tf does this in
 * staging and production, notifyHtmlPlugin (vite.config.ts) in dev and preview. */
export const isNotifyHtmlPath = (pathname: string) =>
  isNotifyPath(pathname) && !FILE_EXTENSION.test(pathname);
